import axios from "axios";

const url = '/rest/user/license/detach';

export const licenseManagement = () => {
    jQuery('.license-management-panel .multiple-input')
        .on('afterAddRow', () => {
            modifyRemainingLicensesCount(-1);
        })
        .on('afterDeleteRow', () => {
            modifyRemainingLicensesCount(1);
        });

    $('.license-detach').on('click', function () {
        const licenseId = $(this).data('license');
        const license = $(this).parent().parent().parent();

        axios.get(url, {params: {license_id: licenseId}})
            .then(function () {
                license.remove();
                modifyRemainingLicensesCount(1);
            }).catch(error => {
                console.log(error);
            });
    });
};

const modifyRemainingLicensesCount = (number) => {
    handleSaveButtonVisibility();
    const $target = $('.license-management-panel #free-license-number');
    const currentValue = Number($target.text());
    const $plusButton = $('.license-management-panel .js-input-plus');

    if (currentValue === 0) {
        $plusButton.removeClass('hidden');
    }

    const licenseNumber = currentValue + number;

    if (isLimitExceeded(licenseNumber)) {
        return;
    }

    $target.text(licenseNumber);

    if (licenseNumber === 0) {
        $plusButton.addClass('hidden');
    }
};

const handleSaveButtonVisibility = () => {
    const body = $('.license-management-panel .multiple-input tbody')[0];
    const currentRowNumber = body ? body.children.length : 0;
    const $saveButton = $('.license-management-panel form button[type="submit"]');

    if (currentRowNumber === 0) {
        $saveButton.addClass('hidden');
        return;
    }

    $saveButton.removeClass('hidden');
};

const isLimitExceeded = (number) => {
    const $target = $('.license-management-panel #total-license-number');
    const currentValue = Number($target.text());

    if (number < 0) {
        return true;
    }

    return number > currentValue;
};
